export default __webpack_public_path__ + "static/media/chance.337f4a02.png";